import {Field} from 'formik';

import {
    FormikNumberInput,
    PlatformFieldset
} from '@flexinet/ui-components';
import {Container} from "@mantine/core";
import {PricesDropdown} from '../../prices/inputs/PricesDropdown';


export const FormComponent = () => {


    return (
        <Container>
            <PlatformFieldset legend={'Subscription Item'}>
                <Field
                    name='priceId'
                    label='Price'
                    description='Please select the price'
                    component={PricesDropdown}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='quantity'
                    label='Quantity'
                    description='Please enter the quantity'
                    component={FormikNumberInput}
                    withAsterisk
                    my={'xl'}
                />


            </PlatformFieldset>
        </Container>
    );
};
